let sessionInfo: any = null

export function sessionMagic(el: Node, { Alpine, effect }: any) {
  if (sessionInfo !== null) return sessionInfo

  const $device = Alpine.evaluate(el, '$device')

  const session = JSON.parse(sessionStorage.getItem('$session') ?? '{}')

  sessionInfo = Alpine.reactive(
    Object.assign(
      {
        mode: $device.mode,
        language: $device.language
      },
      session
    )
  )

  let oldLanguage = sessionInfo.language

  if (window.location.pathname.match(/^\/[a-z]{2}\//)) {
    const [, pathLanguage] = window.location.pathname.split('/')
    if (pathLanguage !== oldLanguage) {
      sessionInfo.language = pathLanguage
      oldLanguage = pathLanguage
    }
  } else if (sessionInfo.language !== 'en' && !window.location.pathname.startsWith(`/${sessionInfo.language}/`)) {
    let newPath = window.location.pathname.replace(/^\/[a-z]{2}\//, '/')
    window.location.pathname = '/' + sessionInfo.language + newPath
    return
  }

  effect(() => {
    // This will get run every time sessionInfo changes at all
    sessionStorage.setItem('$session', JSON.stringify(sessionInfo))

    // update the dark mode class
    //const htmlEl = document.documentElement;
    const htmlEl = document.body

    let mode = sessionInfo.mode
    if (mode === 'system') {
      mode = $device.mode
    }
    if (mode === 'dark') {
      htmlEl.classList.add('dark')
    } else {
      htmlEl.classList.remove('dark')
    }

    if (oldLanguage !== sessionInfo.language) {
      const newLanguage = sessionInfo.language
      let newPath = window.location.pathname
      if (oldLanguage !== 'en') {
        // if not english, then the first 3 chars are the old language prefix
        newPath = newPath.substring(3)
      }

      if (newLanguage !== 'en') {
        newPath = `/${newLanguage}${newPath}`
      }

      oldLanguage = sessionInfo.language
      window.location.pathname = newPath
    }
  })

  return sessionInfo
}
